import { render, staticRenderFns } from "./StudyNewPageCommonFixedTopics.vue?vue&type=template&id=5a212386&scoped=true"
import script from "./StudyNewPageCommonFixedTopics.vue?vue&type=script&lang=js"
export * from "./StudyNewPageCommonFixedTopics.vue?vue&type=script&lang=js"
import style0 from "./StudyNewPageCommonFixedTopics.vue?vue&type=style&index=0&id=5a212386&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a212386",
  null
  
)

export default component.exports